import { gql } from '@apollo/client';

const GET_MAIL_SENDER = gql`
  query GetMailSender {
    getMailSender
  }
`;

export default GET_MAIL_SENDER;
